<template>
  <a href="" @click.prevent="showContact">
    {{ label }}
  </a>
</template>

<script lang="ts">
import { setContactVisible } from "@/state/appState";
import { defineComponent } from "vue";

export default defineComponent({
  components: {},
  emits: ["contact"],
  props: {
    label: { type: String, default: "contact us" },
  },
  data() {
    return {};
  },
  methods: {
    showContact() {
      this.$emit("contact");
      setContactVisible(true);
    },
  },
});
</script>
